import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { Logo } from "@/components/Shared";
import { useI18n } from "@/context/I18nContext";

export const SUPPORT_EMAIL = "[EMAIL KONTAK]";

export const GRID_BG = {
  backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='16' height='16' fill='none' stroke='rgb(255 255 255 / 0.9)'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e\")",
};

export const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.55, delay },
});

export function useDarkBody() {
  useEffect(() => {
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#020617";
    return () => { document.body.style.backgroundColor = prev; };
  }, []);
}

export function SectionShell({ id, children, className = "", inner = "max-w-7xl px-5" }) {
  return (
    <section id={id} className={`relative overflow-hidden bg-slate-950 py-24 lg:py-32 ${className}`}>
      <div aria-hidden className="pointer-events-none absolute inset-0 opacity-10" style={GRID_BG} />
      <div aria-hidden className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />
      <div className={`relative z-10 mx-auto ${inner}`}>{children}</div>
    </section>
  );
}

export function SectionHead({ label, title, accent, sub, testid }) {
  return (
    <div className="text-center" data-testid={testid}>
      <motion.span {...fadeUp()} className="inline-block text-sm font-medium uppercase tracking-wider text-emerald-400">{label}</motion.span>
      <motion.h2 {...fadeUp(0.05)} className="mt-4 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title} <span className="text-emerald-400">{accent}</span>
      </motion.h2>
      {sub && <motion.p {...fadeUp(0.1)} className="mx-auto mt-4 max-w-2xl text-base text-slate-400 md:text-lg">{sub}</motion.p>}
    </div>
  );
}

export function LandingFooter() {
  const { t, lang } = useI18n();
  const id = lang === "id";
  const link = "text-slate-400 transition-colors hover:text-emerald-400";
  return (
    <footer className="border-t border-slate-800 bg-slate-950" data-testid="landing-footer">
      <div className="mx-auto max-w-7xl px-5 py-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <Link to="/" data-testid="footer-home-link"><Logo className="text-white" /></Link>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm">
            <Link to="/privacy" data-testid="footer-privacy-link" className={link}>{id ? "Kebijakan Privasi" : "Privacy Policy"}</Link>
            <Link to="/terms" data-testid="footer-terms-link" className={link}>{id ? "Syarat Layanan" : "Terms of Service"}</Link>
            <span data-testid="footer-contact" className="inline-flex items-center gap-1.5 text-slate-400">
              <Mail className="h-4 w-4 text-emerald-400" /> {SUPPORT_EMAIL}
            </span>
          </nav>
        </div>
        <p className="mt-8 border-t border-slate-800/60 pt-6 text-xs text-slate-500" data-testid="footer-disclaimer">© 2026 FitBersama. {t("disclaimer")}</p>
      </div>
    </footer>
  );
}
